export default "__VITE_ASSET__BSB_8J$g__"